import { useEffect, useState } from 'react';
import classes from './ProviderProfile.module.scss';
import axios from '../../utils/axiosCompanyProxy';
import { Button, Rating, Pagination, Avatar } from '@mui/material';
// import HeaderLogo from './assets/DlpProviderHeaderLogo.svg';
// import HeaderAccountant from './assets/DlpProviderHeaderAccountant.svg';
import LongArrowLeft from '../assets/DlpProviderLongArrowLeft.svg';
import HandWave from '../assets/DlpProviderHandWave.svg';
import Shield from '../assets/DlpProviderShield.svg';
import Approved from '../assets/DlpApproved.svg';
import StarBlue from '../assets/DlpStarBlue.svg';
import LangHU from '../../images/icons/circle-flags/hu.svg';
import LangGB from '../../images/icons/circle-flags/gb.svg';
import LangDE from '../../images/icons/circle-flags/de.svg';
import LangFR from '../../images/icons/circle-flags/fr.svg';
import LangCN from '../../images/icons/circle-flags/cn.svg';
import LangRU from '../../images/icons/circle-flags/ru.svg';
import LangRO from '../../images/icons/circle-flags/ro.svg';
import LangES from '../../images/icons/circle-flags/es.svg';
import LangIT from '../../images/icons/circle-flags/it.svg';
import AttFlexibility from '../components/AttFlexibility';
import AttPrecision from '../components/AttPrecision';
import AttPricevalue from '../components/AttPriceValue';
import AttIndustryExperience from '../components/AttIndustryExperience';
import AttIndustryProfessionalism from '../components/AttProfessionalism';
import Industry from '../assets/DlpInfos/DlpIndustry.svg';
import StarGrey from '../assets/DlpInfos/DlpStarGrey.svg';
import NotVerifiedYet from '../assets/DlpNotVerifiedYet.svg';
import DlpMUIProfileImageDefault from '../assets/DlpMUIProfileImageDefault.svg';
import i18n from '../../utils/i18n';
import { useTranslation } from 'react-i18next';
import { safeRenderContent } from '../../utils/htmlUtils';

const FRONT_END_URL =
	process.env.REACT_APP_FRONT_END_URL || 'https://dashboard-hu.bookkeepie.com';

const ProviderProfile = ({ data, setOpen, setOpenForward }) => {
	// All hooks must be called before any conditional returns
	const [providerCompanyName, setProviderCompanyName] = useState('');
	const [ProfileImage, setProfileImage] = useState('');
	const [description, setDescription] = useState('');
	const [liabilityInsurance, setLiabilityInsurance] = useState('');
	const [reviews, setReviews] = useState([]);
	const [languages, setLanguages] = useState([]);
	const [packageType, setPackageType] = useState('');
	const [averages, setAverages] = useState({});
	const [currentPage, setCurrentPage] = useState(1);
	const [industryExperience, setIndustryExperience] = useState({});
	const [industries, setIndustries] = useState([]);
	const [companyFilters, setCompanyFilters] = useState({});
	const [showMore, setShowMore] = useState(false);
	const [city, setCity] = useState('');
	const [chosenProviderCount, setChosenProviderCount] = useState(0);

	const { t } = useTranslation();

	// Get provider ID safely - use empty string if data is not available
	const id = data?.providerID || '';
	const reviewsPerPage = 9;
	const indexOfLastReview = currentPage * reviewsPerPage;
	const indexOfFirstReview = indexOfLastReview - reviewsPerPage;
	const currentReviews = reviews.slice(indexOfFirstReview, indexOfLastReview);
	const totalPages = Math.ceil(reviews.length / reviewsPerPage);

	// All useEffect hooks must also be before any early returns
	useEffect(() => {
		if (!data || !data.providerID) return;

		const fetchProviderDetails = async () => {
			try {
				const response = await axios.get(`/api/provider/${data.providerID}`);
				//console.log(response, 'RESPONSE');
				setCity(response.data.provider.provider_info.city);
				setProviderCompanyName(
					response.data.provider.provider_info.companyname,
				);
				setProfileImage(
					response.data.provider.provider_media.profileImage ||
						DlpMUIProfileImageDefault,
				);
				setDescription(response.data.provider.provider_info.description);
				setLiabilityInsurance(
					response.data.provider.provider_liability_insurance.accounting,
				);
				setLanguages(response.data.provider.provider_languages || {});
				setPackageType(response.data.provider.provider_package.packageType);
				setIndustryExperience(
					response.data.provider.provider_industry_experience,
				);
				setIndustries(response.data.provider.provider_industry_restrictions);
				setCompanyFilters(response.data.provider.provider_business_filter);
			} catch (error) {
				console.error('Error fetching provider details:', error);
			}
		};
		fetchProviderDetails();

		const fetchChosenProviderCount = async () => {
			try {
				const providerName = data.providerName;
				if (!providerName || typeof providerName !== 'string') return;
				// Same endpoint as company searchFlow provider profile — counts company Request docs (chosenprovider field).
				const response = await axios.get(
					`/api/request/getchosenprovidercount/${encodeURIComponent(
						providerName,
					)}`,
				);
				// console.log('COUNTPROV RESPONSE', response);
				// console.log('COUNTPROV', response.data.chosenProviderCount);
				if (response.data) {
					setChosenProviderCount(response.data.chosenProviderCount);
				} else {
					throw new Error('Invalid response data!');
				}
			} catch (error) {
				console.error('Error fetching chosenprovider count:', error);
			}
		};
		fetchChosenProviderCount();
	}, [id, data]);

	let urlVariable = '';

	useEffect(() => {
		urlVariable = encodeURIComponent(providerCompanyName);
	}, [providerCompanyName]);

	useEffect(() => {
		if (!id) return;

		const fetchProviderReviews = (id) => {
			try {
				let data = JSON.stringify({ providerID: id });
				axios
					.post('/api/review/id', data, {
						headers: {
							'Content-Type': 'application/json',
						},
					})
					.then((response) => {
						//console.log('PROVIDER REVIEWS', response);
						setReviews(response.data.review);
						setAverages(pickAttributes(response.data.review));
					})
					.catch((error) => {
						console.log('AXIOS ERROR: ', error.response.data);
					});
			} catch (error) {
				console.error('Error fetching provider reviews:', error);
			}
		};
		fetchProviderReviews(id);
	}, [id]);

	// Now we can check data validity after all hooks are declared
	if (!data || !data.providerID) {
		return (
			<div style={{ padding: '2rem', textAlign: 'center' }}>
				<p>Provider data not available</p>
			</div>
		);
	}

	const handlePageChange = (event, value) => {
		setCurrentPage(value);
	};

	const handleShowMore = (e) => {
		e.stopPropagation();
		setShowMore(true);
	};

	const handleShowLess = (e) => {
		e.stopPropagation();
		setShowMore(false);
	};

	const calculateAccountLifetimeInDays = (dateTime) => {
		try {
			console.log(dateTime, 'DATETIME');
			let inputDate;

			// Handle undefined/null/empty values
			if (!dateTime && dateTime !== 0) {
				// Use a safe fallback date (January 1, 2025 in milliseconds)
				inputDate = new Date(1735689600000);
			} else if (typeof dateTime === 'number') {
				// Handle Unix timestamps
				// If the number is less than 1e12, it's likely in seconds, convert to milliseconds
				if (dateTime < 1e12 && dateTime > 0) {
					inputDate = new Date(dateTime * 1000);
				} else {
					inputDate = new Date(dateTime);
				}
			} else if (typeof dateTime === 'string' && dateTime.trim() !== '') {
				// Handle string dates - Safari is strict about date formats
				const trimmedDate = dateTime.trim();

				// Try parsing as ISO string first (most reliable)
				if (
					trimmedDate.includes('T') ||
					trimmedDate.match(/^\d{4}-\d{2}-\d{2}/)
				) {
					// ISO format or date-only ISO format
					inputDate = new Date(trimmedDate);
				} else if (
					trimmedDate.includes('-') &&
					trimmedDate.split('-').length === 2
				) {
					// Handle MM-DD format by creating a date in the current year
					const parts = trimmedDate.split('-');
					const month = parseInt(parts[0], 10);
					const day = parseInt(parts[1], 10);

					// Validate month and day
					if (
						!isNaN(month) &&
						!isNaN(day) &&
						month >= 1 &&
						month <= 12 &&
						day >= 1 &&
						day <= 31
					) {
						const currentYear = new Date().getFullYear();
						inputDate = new Date(currentYear, month - 1, day);
					} else {
						// Invalid MM-DD format, use fallback
						inputDate = new Date(1735689600000);
					}
				} else {
					// Try parsing as-is, but if it fails, use fallback
					inputDate = new Date(trimmedDate);
				}
			} else {
				// Fallback for any other type or empty string
				inputDate = new Date(1735689600000);
			}

			const currentDate = new Date();

			// Validate the date - Safari might return Invalid Date
			if (isNaN(inputDate.getTime()) || !inputDate.getTime()) {
				console.warn('Invalid date format, using fallback:', dateTime);
				// Use fallback date if parsing failed
				inputDate = new Date(1735689600000);
			}

			const timeDifference = currentDate - inputDate; // milliszekundumban adja meg
			const daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // 1000 milliszekundum 60 másodperc 60 perc 24 óra

			// Ensure we return a valid number
			return isNaN(daysDifference) ? 0 : daysDifference;
		} catch (error) {
			// Catch any unexpected errors and return a safe default
			console.error('Error calculating account lifetime:', error, dateTime);
			return 0;
		}
	};

	const renderLanguages = (languages) => {
		const languageIcons = {
			hungarian: LangHU,
			english: LangGB,
			german: LangDE,
			french: LangFR,
			chinese: LangCN,
			russian: LangRU,
			romanian: LangRO,
			spanish: LangES,
			italian: LangIT,
		};

		return Object.keys(languages)
			.filter((language) => languages[language] && language !== 'hungarian')
			.map((language, index) => (
				<img
					key={index}
					src={languageIcons[language]}
					alt={`${language} flag`}
					className={classes.langIcon}
				/>
			));
	};

	const calculateAverageRating = (review) => {
		const {
			flexibility,
			industryexperience,
			precision,
			pricevalue,
			professionalism,
		} = review;
		const total =
			flexibility +
			industryexperience +
			precision +
			pricevalue +
			professionalism;
		return Number((total / 5).toFixed(1));
	};

	const pickAttributes = (reviews) => {
		if (reviews.length === 0) return 0;

		const totalFlexibility = reviews.reduce(
			(total, review) => total + review.flexibility,
			0,
		);
		const averageFlexibility = (totalFlexibility / reviews.length).toFixed(1);

		const totalIndustryexperience = reviews.reduce(
			(total, review) => total + review.industryexperience,
			0,
		);
		const averageIndustryexperience = (
			totalIndustryexperience / reviews.length
		).toFixed(1);

		const totalPrecision = reviews.reduce(
			(total, review) => total + review.precision,
			0,
		);
		const averagePrecision = (totalPrecision / reviews.length).toFixed(1);

		const totalPricevalue = reviews.reduce(
			(total, review) => total + review.pricevalue,
			0,
		);
		const averagePricevalue = (totalPricevalue / reviews.length).toFixed(1);

		const totalProfessionalism = reviews.reduce(
			(total, review) => total + review.professionalism,
			0,
		);
		const averageProfessionalism = (
			totalProfessionalism / reviews.length
		).toFixed(1);

		const numberOfAttributes = 5;

		const totalAverage = (
			(parseFloat(averageFlexibility) +
				parseFloat(averageIndustryexperience) +
				parseFloat(averagePrecision) +
				parseFloat(averagePricevalue) +
				parseFloat(averageProfessionalism)) /
			numberOfAttributes
		).toFixed(1);

		return {
			averageFlexibility: parseFloat(averageFlexibility),
			averageIndustryexperience: parseFloat(averageIndustryexperience),
			averagePrecision: parseFloat(averagePrecision),
			averagePricevalue: parseFloat(averagePricevalue),
			averageProfessionalism: parseFloat(averageProfessionalism),
			totalAverage: parseFloat(totalAverage),
		};
	};

	const renderIndustryExperience = (industryExperience) => {
		return Object.keys(industryExperience)
			.filter((industry) => industryExperience[industry] >= 4)
			.map((industry, index) => (
				<div key={index}>{t(`industrylabels.${industry}`)}</div>
			));
	};

	const renderCompanyTypes = (companyFilters) => {
		return Object.keys(companyFilters)
			.filter((company) => companyFilters[company] === true)
			.map((company, index) => (
				<div key={index}>{t(`companyforms.${company}`)}</div>
			));
	};

	const renderIndustries = (industries) => {
		if (industries) {
			let ind = industries.filter((item) => item.on).map((i) => i.id);
			return ind.map((e, idx) => (
				<div key={idx}>{t(`industrylabels.${e}`)}</div>
			));
		} else return [];
	};

	return (
		<div
			className={classes.dlpProviderProfile}
			onClick={() => {
				setOpen(false);
			}}>
			<div className={classes.dlpProviderBackButton}>
				<Button className={classes.dlpProviderBackButtonCustom}>
					<img
						src={LongArrowLeft}
						alt="Long Arrow Left"
						className={classes.dlpLongArrowLeft}
					/>
					{i18n.t('general.backbutton')}
				</Button>
			</div>

			<div className={classes.dlpProviderHeaderSleek}>
				<div className={classes.dlpProviderHeaderTextSleek}>
					<div className={classes.dlpProviderHeaderTextUpSleek}>
						{i18n.t('providerprofile.accountants')} / {city} /{' '}
						{providerCompanyName}
					</div>
					<div className={classes.dlpProviderHeaderTextDownSleek}>
						<span>{i18n.t('providerprofile.gettoknowbetter')}</span>{' '}
						<span>{providerCompanyName}</span>
					</div>
				</div>
			</div>
			<div className={classes.dlpDividerHeaderSleek}></div>
			<div className={classes.dlpProviderContent}>
				<div
					className={` ${classes.dlpProviderContentLeft} ${
						showMore ? classes.show : ''
					}`}>
					<div className={classes.dlpProviderMainContainer}>
						<div className={classes.dlpProviderMainContainerLeft}>
							<div className={classes.dlpProfileImageContainer}>
								{ProfileImage ? (
									<img
										src={ProfileImage}
										alt="Profile"
										className={classes.dlpProfileImage}
									/>
								) : (
									<img
										src={DlpMUIProfileImageDefault}
										alt={i18n.t('general.profileDefault')}
										className={classes.dlpProfileImageDefault}
									/>
								)}
								{packageType === 'premium' && (
									<img
										src={Approved}
										alt="Profile"
										className={classes.dlpApproved}></img>
								)}
							</div>
						</div>
						<div className={classes.dlpProviderMainContainerRight}>
							<div className={classes.dlpProviderProfileName}>
								{providerCompanyName}
							</div>
							{reviews.length > 0 ? (
								<div className={classes.dlpProviderProfileAvgContainer}>
									<div className={classes.dlpProviderProfileAvgStars}>
										<Rating
											value={averages.totalAverage || 0}
											precision={0.1}
											readOnly
											sx={{ fontSize: '1rem' }}
										/>
										<div className={classes.dlpProviderProfileAvgNumber}>
											{averages.totalAverage}
										</div>
										<div className={classes.dlpProviderProfileReviewsNumber}>
											({reviews.length})
										</div>
									</div>
								</div>
							) : (
								<div className={classes.dlpNotVerifiedYetConatiner}>
									<img
										src={NotVerifiedYet}
										alt="Not Verified Yet"
										className={classes.dlpNotVerifiedYet}
									/>
									<div className={classes.dlpNotVerifiedYetText}>
										{i18n.t('provider.notverifiedyet')}
									</div>
								</div>
							)}
							{/* <div className={classes.dlpRFPButton}>
								<Button
									className={classes.dlpRFPButtonCustom}
									onClick={(e) => {
										setOpenForward(true);
										// e.stopPropagation();
										// localStorage.setItem('selectedSP', providerCompanyName);
										// window.open(`${FRONT_END_URL}/company/request/1`);
									}}>
									{i18n.t('providerdashboard.requestcapital')}
								</Button>
							</div> */}
							{renderLanguages(languages).length > 0 && (
								<div className={classes.dlpLanguagesContainer}>
									{renderLanguages(languages)}
								</div>
							)}
						</div>
					</div>
					{reviews.length > 0 && (
						<>
							<div className={classes.DlpDividerContentLeft}></div>
							<div className={classes.dlpAttributesContainer}>
								<AttFlexibility inputValue={averages.averageFlexibility} />
								<AttPrecision inputValue={averages.averagePrecision} />
								<AttPricevalue inputValue={averages.averagePricevalue} />
								<AttIndustryExperience
									inputValue={averages.averageIndustryexperience}
								/>
								<AttIndustryProfessionalism
									inputValue={averages.averageProfessionalism}
								/>
							</div>
						</>
					)}
					{!showMore && (
						<div className={classes.dlpShowMoreButton}>
							<Button onClick={handleShowMore}>
								{i18n.t('provider.moreinfo')}
							</Button>
						</div>
					)}
					<div className={`dlpHiddenContent ${showMore ? 'show' : ''}`}>
						{/* {renderIndustryExperience(industryExperience).length > 0 && (
							<>
								<div className={classes.DlpDividerContentLeft}></div>
								<div className={classes.dlpIndustryContainer}>
									<img
										src={Industry}
										alt='Industry'
										className={classes.dlpIndustry}
									/>
									<div className={classes.dlpIndustryText}>
										{i18n.t('providerprofile.expertinindustries')}
									</div>
								</div>
								<div className={classes.dlpIndustryContainerCards}>
									{renderIndustryExperience(industryExperience).map(
										(industry, index) => (
											<div key={index} className={classes.dlpIndustryCard}>
												{industry}
											</div>
										)
									)}
								</div>
							</>
						)} */}
						{reviews.length > 0 && (
							<>
								<div className={classes.DlpDividerContentLeft}></div>
								<div className={classes.dlpRatingSumContainer}>
									<img
										src={StarGrey}
										alt={i18n.t('general.starGrey')}
										className={classes.dlpStarGrey}
									/>
									<div className={classes.dlpRatingSumAvgNumber}>
										{averages.totalAverage}
									</div>
									<div className={classes.dlpRatingSumText}>
										{i18n.t('general.reviewsmall')}
									</div>
								</div>
							</>
						)}
						{/* Temporarily hidden: package size, digital badge, "days without complaint", client count (shared URL + search flow both use this component) */}
						{/*
						<div className={classes.dlpPackageSizeContainer}>
							<img
								src={PackageSize}
								alt="PackageSize"
								className={classes.dlppackageSize}
							/>
							{packageSize === 'entrepreneur' && (
								<div className={classes.dlpPackageSizeText1}>
									{i18n.t('general.entrepreneur')}
								</div>
							)}
							{packageSize === 'small_office' && (
								<div className={classes.dlpPackageSizeText1}>
									{i18n.t('provider.small_acc_office')}
								</div>
							)}
							{(packageSize === 'office' || packageSize === 'enterprise') && (
								<div className={classes.dlpPackageSizeText1}>
									{i18n.t('provider.large_acc_office')}
								</div>
							)}
						</div>
						{digitalBadge !== 'tbd' &&
							digitalBadge !== 'none' &&
							digitalBadge !== undefined && (
								<div className={classes.dlpDigBadgeContainer}>
									<img
										src={DigBadge}
										alt="DigBadge"
										className={classes.dlpDigBadge}
									/>
									<div className={classes.dlpDigBadgeTextContainer}>
										<div className={classes.dlpDigBadgeText1}>
											{i18n.t('provider.digital')}
										</div>
										<div className={classes.dlpDigBadgeText1}>
											{i18n.t('provider.withcertification')}
										</div>
										<div className={classes.dlpDigBadgeText2}>
											{i18n.t('provider.has')}
										</div>
									</div>
								</div>
							)}
						<div className={classes.DlpDividerContentLeft}></div>
						<div className={classes.dlpWoComplaintContainer}>
							<img
								src={WoComplaint}
								alt="WoComplaint"
								className={classes.dlpWoComplaint}
							/>
							<div className={classes.dlpWoComplaintTextContainer}>
								<div className={classes.dlpWoComplaintNumber}>
									{(() => {
										try {
											const startDate =
												(data &&
													data.provider_package &&
													data.provider_package.startDate) ||
												(data && data.startDate) ||
												null;
											return calculateAccountLifetimeInDays(startDate);
										} catch (error) {
											console.error('Error rendering account lifetime:', error);
											return 0;
										}
									})()}
								</div>
								<div className={classes.dlpWoComplaintText}>
									{i18n.t('provider.workday')}
								</div>
								<div className={classes.dlpWoComplaintText}>
									{i18n.t('provider.complaint')}
								</div>
								<div className={classes.dlpWoComplaintText}>
									{i18n.t('provider.without')}
								</div>
							</div>
						</div>
						<div className={classes.NoOfCustomersContainer}>
							<img
								src={NoOfCustomers}
								alt="NoOfCustomers"
								className={classes.dlpNoOfCustomers}
							/>
							<div className={classes.dlpNoOfCustomersTextContainer}>
								{chosenProviderCount > 0 ? (
									<>
										<div className={classes.dlpNoOfCustomersNumber}>
											{chosenProviderCount}
										</div>
										<div className={classes.dlpNoOfCustomersText1}>
											{i18n.t('general.bookkeepie')}
										</div>
										<div className={classes.dlpNoOfCustomersText2}>
											{i18n.t('general.client')}
										</div>
									</>
								) : (
									<>
										<div className={classes.dlpNoOfCustomersText1}>
											{i18n.t('provider.noclientsyet')}
										</div>
									</>
								)}
							</div>
						</div>
						*/}
						<div className={classes.dlpShowLessButton}>
							<Button onClick={handleShowLess}>
								{i18n.t('providerprofile.lessinfo')}
							</Button>
						</div>
					</div>
				</div>
				<div className={classes.dlpProviderContentRight}>
					{description && (
						<div className={classes.dlpProviderCard}>
							<div className={classes.dlpProviderIntroduction}>
								<img
									src={HandWave}
									alt={i18n.t('general.handWave')}
									className={classes.dlpHandWave}
								/>
								{i18n.t('general.description')}
							</div>
							<div
								className={classes.dlpProviderIntroductionText}
								{...safeRenderContent(description)}
							/>
						</div>
					)}
					{liabilityInsurance === true && (
						<div className={classes.dlpProviderCard}>
							<div className={classes.dlpProviderLiabilityInsurance}>
								<img src={Shield} alt="Shield" className={classes.dlpShield} />
								{i18n.t('provider.hasliabilityinsurance')}
							</div>
							<div className={classes.dlpProviderLiabilityInsuranceText}>
								{i18n.t('provider.liabilityinsurancetext')}
							</div>
						</div>
					)}
					{renderCompanyTypes(companyFilters).length > 0 && (
						<div className={classes.dlpProviderCard}>
							<div className={classes.dlpIndustryContainer}>
								<img
									src={Industry}
									alt="Industry"
									className={classes.dlpIndustry}
								/>
								<div className={classes.dlpIndustryText}>
									{i18n.t('provider.filterscompanies')}
								</div>
							</div>
							<div className={classes.dlpIndustryContainerCards}>
								{renderCompanyTypes(companyFilters).map((industry, index) => (
									<div key={index} className={classes.dlpIndustryCard}>
										{industry}
									</div>
								))}
							</div>
						</div>
					)}
					{renderIndustries(industries).length > 0 && (
						<div className={classes.dlpProviderCard}>
							<div className={classes.dlpIndustryContainer}>
								<img
									src={Industry}
									alt="Industry"
									className={classes.dlpIndustry}
								/>
								<div className={classes.dlpIndustryText}>
									{i18n.t('provider.filtersindustries')}
								</div>
							</div>
							<div className={classes.dlpIndustryContainerCards}>
								{renderIndustries(industries).map((industry, index) => (
									<div key={index} className={classes.dlpIndustryCard}>
										{industry}
									</div>
								))}
							</div>
						</div>
					)}
					{renderIndustryExperience(industryExperience).length > 0 && (
						<div className={classes.dlpProviderCard}>
							<div className={classes.dlpIndustryContainer}>
								<img
									src={Industry}
									alt="Industry"
									className={classes.dlpIndustry}
								/>
								<div className={classes.dlpIndustryText}>
									{i18n.t('provider.expertinindustries')}
								</div>
							</div>
							<div className={classes.dlpIndustryContainerCards}>
								{renderIndustryExperience(industryExperience).map(
									(industry, index) => (
										<div key={index} className={classes.dlpIndustryCard}>
											{industry}
										</div>
									),
								)}
							</div>
						</div>
					)}
					<div className={classes.dlpProviderCardLast}>
						{reviews.length === 0 ? (
							<div className={classes.dlpProviderReviewsNull}>
								<img
									src={StarBlue}
									alt={i18n.t('general.starBlue')}
									className={classes.dlpStarBlue}
								/>
								<div className={classes.dlpSumOfReviews}>{reviews.length}</div>
								{i18n.t('general.review')}
							</div>
						) : (
							<div className={classes.dlpProviderReviews}>
								<img
									src={StarBlue}
									alt={i18n.t('general.starBlue')}
									className={classes.dlpStarBlue}
								/>
								<div className={classes.dlpSumOfReviews}>{reviews.length}</div>
								{i18n.t('general.review')}
							</div>
						)}
						<div className={classes.dlpProviderReviewsContainer}>
							{currentReviews.map((review, index) => (
								<div key={index} className={classes.dlpProviderReviewCard}>
									<div className={classes.dlpProviderReviewHeader}>
										<div className={classes.dlpProviderReviewReviewer}>
											{review.reviewer}
										</div>
										<div className={classes.dlpProviderReviewDate}>
											{review.date}
										</div>
									</div>
									<div className={classes.dlpProviderReviewAvgContainer}>
										<div className={classes.dlpProviderReviewAvgStars}>
											<Rating
												value={calculateAverageRating(review)}
												precision={0.1}
												readOnly
												sx={{ fontSize: '1rem' }}
											/>
										</div>
										<div className={classes.dlpProviderReviewAvgNumber}>
											{calculateAverageRating(review)}
										</div>
									</div>
									<div className={classes.dlpProviderReviewText}>
										{review.review}
									</div>
								</div>
							))}
						</div>
						{totalPages > 0 && (
							<Pagination
								count={totalPages}
								page={currentPage}
								onClick={(e) => e.stopPropagation()}
								onChange={handlePageChange}
								color="primary"
								className={classes.dlpReviewsPaginator}
								shape="rounded"
								sx={{
									'& .MuiPaginationItem-root': {
										color: '#4D5BEC',
										border: '1px solid #E3E5E9',
										borderRadius: '6px',
									},
									'& .MuiPaginationItem-root.Mui-selected': {
										backgroundColor: '#4D5BEC',
										color: '#ffffff',
										border: '1px solid #E3E5E9',
										borderRadius: '6px',
									},
									'& .MuiPaginationItem-root.Mui-selected:hover': {
										backgroundColor: '#4D5BEC',
										color: '#ffffff',
										border: '1px solid #E3E5E9',
										borderRadius: '6px',
									},
								}}
							/>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProviderProfile;
